import { RSAA } from 'redux-api-middleware'

/**
 * This middleware intercepts RSAA actions before they reach
 * redux-api-middleware and stores the endpoint URL in the action's meta field
 * for error tracking. This allows downstream middleware to access the original
 * endpoint URL even when errors occur, as redux-api-middleware doesn't include
 * URLs in error actions.
 */
export default ({ getState }) =>
  next =>
  action => {
    // Only process RSAA actions
    if (action[RSAA]) {
      const rsaaAction = action[RSAA]

      // Extract the endpoint (could be a string or function)
      const endpoint =
        typeof rsaaAction.endpoint === 'function'
          ? rsaaAction.endpoint(getState())
          : rsaaAction.endpoint

      // Store the endpoint in all three action types (REQUEST, SUCCESS, ERROR)
      // so it's available regardless of the outcome
      const enhancedTypes = rsaaAction.types.map(type => {
        if (typeof type === 'string') {
          // Simple string type - convert to object with meta
          return {
            type,
            meta: { endpoint },
          }
        } else if (typeof type === 'object') {
          // Already an object - add/merge meta
          return {
            ...type,
            meta: {
              ...type.meta,
              endpoint,
            },
          }
        }
        return type
      })

      // Return the enhanced action
      return next({
        [RSAA]: {
          ...rsaaAction,
          types: enhancedTypes,
        },
      })
    }

    // Pass through non-RSAA actions unchanged
    return next(action)
  }
